import axios from "libs/axios";
import { useQuery, UseQueryOptions } from "react-query";

import { AxiosError } from "axios";
import { shopAndAcceptorDTO } from "../type";

interface shopAndAcceptorRequest {
  merchantId?: number;
}

const shopAndAcceptor = async (data: shopAndAcceptorRequest) => {
  return await axios
    .get(`/api/v1/ShopAndAcceptor/get-by-merchantId`, {
      params: { MerchantId: data.merchantId, version: "1" },
    })
    .then((res) => res.data)
    .catch((err) => err.data);
};

export const useShopAndAcceptor = (
  data: shopAndAcceptorRequest,
  options?: UseQueryOptions<shopAndAcceptorDTO, AxiosError>
) => {
  return useQuery<shopAndAcceptorDTO, AxiosError>(
    [`/api/v1/ShopAndAcceptor/get-by-merchantId/${data.merchantId}`],
    async () => shopAndAcceptor(data),
    {
      ...options,
      enabled: !!data.merchantId,
    }
  );
};
